import { render, staticRenderFns } from "./Vacation.vue?vue&type=template&id=23d6d085&"
import script from "./Vacation.vue?vue&type=script&lang=js&"
export * from "./Vacation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports